import { UserRow } from '@modules/users/store/types';
import { DomainUsersTableRow } from '@modules/users/types';

export const getDomainUsersRows = (
  domains: string[],
  users: UserRow[],
): DomainUsersTableRow[] => {
  const domainUsersMap = new Map<string, number>();

  domains.forEach((domain) => {
    domainUsersMap.set(domain.replace('@', ''), 0);
  });

  users.forEach((user) => {
    const domain = user.email.split('@')[1];

    if (domainUsersMap.has(domain)) {
      const userCount = domainUsersMap.get(domain) ?? 0;
      domainUsersMap.set(domain, userCount + 1);
    }
  });

  return Array.from(domainUsersMap.entries()).map(([domain, userCount]) => ({
    domain,
    userCount,
  }));
};
